import stringmanagement_data from "../data_json/stringmanagement_data.json";
import subscription_set from "../data_json/subscription_set.json";

interface IString {
  [key: string]: any;
}

export const getString3ByKey = (stringId: number | string) => {
  let str = "";

  if (stringId === 0 || stringId === "") return str;

  let strfile = stringmanagement_data;

  const hasVariation = String(stringId)?.includes("_");
  const varNum = +String(stringId)?.split("_")[1];

  if (!strfile) return str;

  const findValue = strfile?.find((data: IString) =>
    hasVariation
      ? data.STRING_ID === +String(stringId)?.split("_")[0]
      : data.STRING_ID === +stringId
  );

  if (!findValue) return str;

  if (!hasVariation) {
    str = findValue?.STRING_PLAIN ?? "";
  } else if (varNum === 1) {
    str = findValue?.STRING_VAR1 ?? "";
  } else if (varNum === 2) {
    str = findValue?.STRING_VAR2 ?? "";
  } else if (varNum === 3) {
    str = findValue?.STRING_VAR3 ?? "";
  }

  const regex = /(<li>)/g;

  const result = str.replace(regex, "<ul>$1").replace(/(\/li>)/g, "$1</ul>");

  return result;
};

export const getSubsNameBySubsId3 = (subsId: number) => {
  const subsData = subscription_set?.find((s) => s.SUBS_ID === subsId);
  const subsName = getString3ByKey(subsData?.SUBS_NM ?? 0);

  return subsName;
};
